import { useState, useEffect, useCallback } from "react";
import { fetchProduct } from "features/hosting/hostingAPI";
// import custom from "../../assets/scss/Domain.module.scss"; // File sudah dihapus
import { useDispatch, useSelector } from "react-redux";
import { addToCart, removeCartItem, setOrderParams } from "features/common/layouts/cartSlice";
import { notifySuccess } from "components/ToastMessage";
import { formatIDR } from "helpers/utils";
import { Modal } from "react-bootstrap";
import ExistingDomain from "pages/Domain/ExistingDomain";
import { calculateHemat } from "helpers/hematCalculator";

const hostingOptions = [
  { label: "Cloud Hosting Maxmail", value: 729, backupDefaultLabel: "2 Mingguan" },
  { label: "Cloud Hosting Proxima", value: 730, backupDefaultLabel: "2 Mingguan" },
  { label: "Cloud Hosting Hyper Quantum", value: 731, backupDefaultLabel: "Mingguan" },
  { label: "Cloud Hosting WP", value: 711, backupDefaultLabel: "2 Mingguan" },
  { label: "Private Label Reseller Hosting", value: 5, backupDefaultLabel: "2 Mingguan" },
  // { label: "Container Hosting", value: 727, backupDefaultLabel: "2 Mingguan" }
];

const HostingProductSelectorNew = () => {
  const [selectedGid, setSelectedGid] = useState("");
  const [products, setProducts] = useState([]);
  const [selectedPid, setSelectedPid] = useState("");
  const [selectedCycle, setSelectedCycle] = useState("");
  const [cycles, setCycles] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingHostingProduct, setPendingHostingProduct] = useState(null);
  const [backupOption, setBackupOption] = useState("mingguan");
  const [selectedBaseProduct, setSelectedBaseProduct] = useState(null);
  // const [filteredProducts, setFilteredProducts] = useState([]); // COMMENTED: Filter feature
  const [additionalCost, setAdditionalCost] = useState("");
  // const [velocityEnabled, setVelocityEnabled] = useState(false); // COMMENTED: Velocity feature
  // const [velocityCost, setVelocityCost] = useState(""); // COMMENTED: Velocity feature
  const dispatch = useDispatch();
  const { productsList } = useSelector((state) => state.cart);

  const hasHosting = productsList.some(item => item.type === "hostingaccount" || item.type === "reselleraccount");
  const hasDomain = productsList.some(item =>
    item.type === "register" ||
    item.type === "transfer" ||
    item.type === "backorder-register" ||
    item.type === "backorder"
  );

  useEffect(() => {
    if (selectedGid) {
      setLoadingProducts(true);
      fetchProduct(selectedGid).then((res) => {
        const productList = res.products?.product || [];
        setProducts(productList);
        
        // COMMENTED: Filter feature - hilangkan yang mengandung "+ Backup Harian" dan "+ Velocity" dari dropdown
        // const filtered = productList.filter(prod => 
        //   !prod.name.includes("+ Backup Harian") && 
        //   !prod.name.includes("+ Velocity")
        // );
        // setFilteredProducts(filtered);
        
        setSelectedPid("");
        setCycles([]);
        setBackupOption("mingguan");
        // setVelocityEnabled(false); // COMMENTED: Velocity feature
        setSelectedBaseProduct(null);
        setLoadingProducts(false);
      });
    } else {
      setProducts([]);
      // setFilteredProducts([]); // COMMENTED: Filter feature
      setSelectedPid("");
      setCycles([]);
      setBackupOption("mingguan");
      // setVelocityEnabled(false); // COMMENTED: Velocity feature
      setSelectedBaseProduct(null);
    }
  }, [selectedGid]);

  // Fungsi untuk extract base name produk (tanpa "+ Backup Harian" dan "+ Velocity")
  const extractBaseName = useCallback((productName) => {
    return productName
      .replace(/\s*\+\s*Backup\s*Harian\s*$/i, "")
      .replace(/\s*\+\s*Velocity\s*$/i, "")
      .trim();
  }, []);

  // Fungsi untuk mencari produk dengan backup harian yang sesuai
  const findBackupProduct = useCallback((basePid) => {
    const baseProduct = products.find((p) => p.pid === Number(basePid));
    if (!baseProduct) return null;
    
    const baseName = extractBaseName(baseProduct.name);
    const backupProduct = products.find((p) => {
      const pName = p.name;
      return pName.includes("+ Backup Harian") && 
             !pName.includes("+ Velocity") &&
             extractBaseName(pName) === baseName;
    });
    
    return backupProduct;
  }, [products, extractBaseName]);

  // COMMENTED: Velocity feature - Fungsi untuk mencari produk dengan Velocity yang sesuai
  // const findVelocityProduct = useCallback((basePid) => {
  //   const baseProduct = products.find((p) => p.pid === Number(basePid));
  //   if (!baseProduct) return null;
  //   
  //   const baseName = extractBaseName(baseProduct.name);
  //   const velocityProduct = products.find((p) => {
  //     const pName = p.name;
  //     return pName.includes("+ Velocity") && 
  //            !pName.includes("+ Backup Harian") &&
  //            extractBaseName(pName) === baseName;
  //   });
  //   
  //   return velocityProduct;
  // }, [products, extractBaseName]);

  useEffect(() => {
    if (selectedPid) {
      const product = products.find((p) => p.pid === Number(selectedPid));
      if (product) {
        setSelectedBaseProduct(product);
        const pricing = product.pricing?.IDR || {};
        const availableCycles = [
          { key: "monthly", label: "1 Bulan" },
          { key: "quarterly", label: "3 Bulan" },
          { key: "semiannually", label: "6 Bulan" },
          { key: "annually", label: "1 Tahun" },
          { key: "biennially", label: "2 Tahun" },
          { key: "triennially", label: "3 Tahun" },
        ].filter(
          (cycle) =>
            pricing[cycle.key] &&
            pricing[cycle.key] !== "-1.00" &&
            pricing[cycle.key] !== "0.00"
        );
        setCycles(availableCycles);
        
        // Calculate additional cost untuk backup harian
        const backupProduct = findBackupProduct(selectedPid);
        if (backupProduct) {
          // Untuk GID 709-718, gunakan fixed cost berdasarkan PID list
          const additionalCostPidList1 = [
            529, 527, 533, 531, 1020, 1021, 1025, 1028, 1039, 1042, 1053, 1056, 1067, 1070, 1024, 1038, 1052, 1066,
          ];
          const additionalCostPidList2 = [
            537, 535, 541, 539, 1022, 1026, 1040, 1029, 1043, 1057, 1071, 1054, 1068,
          ];
          const additionalCostPidList3 = [
            1023, 1027, 1041, 1055, 1069, 1044, 1030, 1058, 1072,
          ];
          const additionalCostPidList4 = [1088, 1090, 1092, 1094];

          const pid = Number(selectedPid);
          
          // Check apakah ada di list PID dengan fixed cost
          if (additionalCostPidList1.includes(pid)) {
            setAdditionalCost("+ Rp15.000/bulan");
          } else if (additionalCostPidList2.includes(pid)) {
            setAdditionalCost("+ Rp20.000/bulan");
          } else if (additionalCostPidList3.includes(pid)) {
            setAdditionalCost("+ Rp40.000/bulan");
          } else if (additionalCostPidList4.includes(pid)) {
            setAdditionalCost("+ Rp80.000/bulan");
          } else {
            // Untuk produk lain (MaxMail, Proxima, Core), hitung dari selisih harga monthly
            const baseMonthlyPrice = parseFloat(pricing.monthly || 0);
            const backupMonthlyPrice = parseFloat(backupProduct.pricing?.IDR?.monthly || 0);
            const costDiff = backupMonthlyPrice - baseMonthlyPrice;
            
            if (costDiff > 0) {
              setAdditionalCost(`+ Rp${costDiff.toLocaleString('id-ID')}/bulan`);
            } else {
              setAdditionalCost("");
            }
          }
        } else {
          setAdditionalCost("");
        }
        
        // COMMENTED: Velocity feature - Calculate velocity cost
        // const velocityProduct = findVelocityProduct(selectedPid);
        // if (velocityProduct) {
        //   const baseMonthlyPrice = parseFloat(pricing.monthly || 0);
        //   const velocityMonthlyPrice = parseFloat(velocityProduct.pricing?.IDR?.monthly || 0);
        //   const costDiff = velocityMonthlyPrice - baseMonthlyPrice;
        //   
        //   if (costDiff > 0) {
        //     setVelocityCost(`+ Rp${costDiff.toLocaleString('id-ID')}/bulan`);
        //   } else {
        //     setVelocityCost("");
        //   }
        // } else {
        //   setVelocityCost("");
        // }
      }
    }
  }, [selectedPid, products, findBackupProduct]);

  useEffect(() => {
    if (selectedPid && selectedCycle) {
      dispatch(setOrderParams({ pid: selectedPid, billingcycle: selectedCycle }));
    }
  }, [selectedPid, selectedCycle, dispatch]);

  const handleBackupChange = (e) => {
    setBackupOption(e.target.value);
  };

  // COMMENTED: Velocity feature
  // const handleVelocityChange = (e) => {
  //   setVelocityEnabled(e.target.checked);
  // };

  const handleAddToCart = () => {
    if (!selectedGid || !selectedPid || !selectedCycle) {
      return;
    }

    // Tentukan PID yang akan digunakan berdasarkan pilihan backup
    let finalPid = Number(selectedPid);
    let finalProduct = products.find((p) => p.pid === finalPid);
    
    // Jika user pilih backup harian, cari produk dengan backup harian
    if (backupOption === "harian") {
      const backupProduct = findBackupProduct(selectedPid);
      if (backupProduct) {
        finalPid = backupProduct.pid;
        finalProduct = backupProduct;
      }
    }
    
    // COMMENTED: Velocity feature - Jika user enable velocity, cari produk dengan velocity
    // if (velocityEnabled) {
    //   const velocityProduct = findVelocityProduct(selectedPid);
    //   if (velocityProduct) {
    //     finalPid = velocityProduct.pid;
    //     finalProduct = velocityProduct;
    //   }
    // }

    if (finalProduct) {
      const pricing = finalProduct.pricing?.IDR || {};
      const price = pricing[selectedCycle] || 0;

      const newType = finalProduct.type;
      const newHostingProduct = {
        gid: Number(selectedGid),
        pid: finalPid,
        name: finalProduct.name,
        type: newType,
        price: price,
        billingcycle: selectedCycle,
        monthlyPrice: pricing.monthly || null, // Tambahkan monthlyPrice untuk perhitungan hemat
      };

      const existing = productsList.find(item =>
        (["hostingaccount", "reselleraccount"].includes(item.type) &&
          ["hostingaccount", "reselleraccount"].includes(newType))
      );

      if (existing) {
        setPendingHostingProduct(newHostingProduct);
        setShowConfirmModal(true);
      } else {
        dispatch(addToCart(newHostingProduct));
        notifySuccess(`Produk ${finalProduct.name} (${formatIDR(price)}) berhasil masuk keranjang!`);
      }
    }
  };

  const handleConfirmReplace = () => {
    if (pendingHostingProduct) {
      // Hapus SEMUA produk hosting dari cart
      productsList
        .filter(item => item.type === "hostingaccount" || item.type === "reselleraccount")
        .forEach(item => {
          dispatch(removeCartItem(item.pid));
        });

      // Tambahkan produk hosting baru
      dispatch(addToCart(pendingHostingProduct));
      notifySuccess(
        `Produk ${pendingHostingProduct.name} (${formatIDR(pendingHostingProduct.price)}) berhasil masuk keranjang!`
      );

      setPendingHostingProduct(null);
      setShowConfirmModal(false);
    }
  };

  const handleCancelReplace = () => {
    setPendingHostingProduct(null);
    setShowConfirmModal(false);
  };

  return (
    <>
      <div className="card mb-4 mt-4" style={{ borderRadius: "16px", borderColor: "transparent", boxShadow: "0px 0px 4px rgba(190, 190, 190, 0.5)" }}>
        <div className="card-body p-4">
          <div className="mb-4">
            <label className="form-label fw-bold d-block mb-3" style={{ fontSize: "18px", color: "#333" }}>
              Tambah Produk Hosting Lainnya (Opsional)
            </label>
            <div
              className="py-3 px-4 w-100 rounded-3 hosting-product-banner"
              style={{ backgroundColor: "#FFCF9D" }}
            >
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
                <div className="h6 mb-0 text-center text-md-start hosting-product-banner-text" style={{ fontSize: "16px", color: "#333" }}>
                  Apakah ingin menambahkan Produk Hosting Lainnya?
                </div>
                <button
                  onClick={() => setIsExpanded(!isExpanded)}
                  className="btn btn-outline-qw-primary fw-bold px-4 py-2 rounded-5"
                  style={{ minWidth: "80px", whiteSpace: "nowrap" }}
                >
                  {isExpanded ? "Tidak" : "Ya"}
                </button>
              </div>
            </div>
          </div>

          {isExpanded && (
            <div className="mt-4 pt-3" style={{ borderTop: "1px solid #e0e0e0" }}>
              <div className="row g-4">
                <div className="col-12">
                  <label className="form-label mb-2 fw-bold d-block" style={{ fontSize: "15px", color: "#333" }}>
                    Pilih Tipe Hosting
                  </label>
                  <select
                    className="form-select"
                    style={{ fontSize: "15px", padding: "10px 15px" }}
                    value={selectedGid}
                    onChange={(e) => {
                      setSelectedGid(e.target.value);
                      setProducts([]);
                      setSelectedPid("");
                      setCycles([]);
                      setBackupOption("mingguan");
                      // setVelocityEnabled(false); // COMMENTED: Velocity feature
                    }}
                  >
                    <option value="">Pilih Tipe Hosting</option>
                    {hostingOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </div>
                
                {products.length > 0 || loadingProducts ? (
                  <div className="col-12">
                    <label className="form-label mb-2 fw-bold d-block" style={{ fontSize: "15px", color: "#333" }}>
                      Pilih Paket
                    </label>
                    <select
                      className="form-select"
                      style={{ fontSize: "15px", padding: "10px 15px" }}
                      value={selectedPid}
                      onChange={(e) => {
                        setSelectedPid(e.target.value);
                        setBackupOption("mingguan"); // Reset backup option saat ganti paket
                        // setVelocityEnabled(false); // COMMENTED: Velocity feature - Reset velocity saat ganti paket
                      }}
                      disabled={loadingProducts}
                    >
                      <option value="">
                        {loadingProducts ? "Memuat produk..." : "Pilih Paket"}
                      </option>
                      {!loadingProducts &&
                        products.map((prod) => (
                          <option key={prod.pid} value={prod.pid}>
                            {prod.name}
                          </option>
                        ))}
                    </select>
                  </div>
                ) : null}
                
                {/* Opsi Backup - tampilkan setelah user pilih paket */}
                {/* {!loadingProducts && selectedPid && selectedBaseProduct && (() => {
                  const backupProduct = findBackupProduct(selectedPid);
                  // Hanya tampilkan opsi backup jika ada produk dengan backup harian
                  if (!backupProduct) return null;
                  
                  return (
                    <div className="col-12">
                      <div className="row mb-2 align-items-center">
                        <div className={backupOption === "harian" && additionalCost ? "col-6" : "col-12"}>
                          <label className="form-label mb-0 fw-bold d-block" style={{ fontSize: "15px", color: "#333" }}>
                            Opsi Backup
                          </label>
                        </div>
                        {backupOption === "harian" && additionalCost && (
                          <div className="col-6 text-end">
                            <span className="text-black fw-bold" style={{ fontSize: "14px" }}>
                              {additionalCost}
                            </span>
                          </div>
                        )}
                      </div>
                      <select
                        className="form-select"
                        style={{ fontSize: "15px", padding: "10px 15px" }}
                        value={backupOption}
                        onChange={handleBackupChange}
                      >
                        <option value="mingguan">
                          {hostingOptions.find(opt => opt.value === Number(selectedGid))?.backupDefaultLabel || "2 Mingguan"}
                        </option>
                        <option value="harian">Harian</option>
                      </select>
                    </div>
                  );
                })()} */}
                
                {/* COMMENTED: Velocity feature - Checkbox Velocity - tampilkan setelah user pilih paket */}
                {/* {!loadingProducts && selectedPid && selectedBaseProduct && (() => {
                  const velocityProduct = findVelocityProduct(selectedPid);
                  // Hanya tampilkan checkbox jika ada produk dengan Velocity
                  if (!velocityProduct) return null;
                  
                  return (
                    <div className="col-12">
                      <div className="p-3 bg-light rounded" style={{ border: "1px solid #e0e0e0" }}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="form-check mb-0">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="velocityCheckbox"
                              checked={velocityEnabled}
                              onChange={handleVelocityChange}
                              style={{ cursor: "pointer" }}
                            />
                            <label 
                              className="form-check-label fw-bold" 
                              htmlFor="velocityCheckbox"
                              style={{ fontSize: "15px", color: "#333", cursor: "pointer" }}
                            >
                              Tambah Velocity (cPanel)
                            </label>
                          </div>
                          {velocityEnabled && velocityCost && (
                            <span className="text-black fw-bold" style={{ fontSize: "14px" }}>
                              {velocityCost}
                            </span>
                          )}
                        </div>
                        <small className="text-muted d-block mt-2">
                          Velocity untuk pengguna yang ingin menggunakan panel berjenis cPanel
                        </small>
                      </div>
                    </div>
                  );
                })()} */}
                
                {!loadingProducts && cycles.length > 0 && (
                  <div className="col-12">
                    <label className="form-label mb-2 fw-bold d-block" style={{ fontSize: "15px", color: "#333" }}>
                      Pilih Masa Aktif
                    </label>
                    <select
                      className="form-select"
                      style={{ fontSize: "15px", padding: "10px 15px" }}
                      value={selectedCycle}
                      onChange={(e) => setSelectedCycle(e.target.value)}
                    >
                      <option value="">Pilih Siklus</option>
                      {cycles.map((cycle) => {
                        return (
                          <option key={cycle.key} value={cycle.key}>
                            {cycle.label} 
                          </option>
                        );
                      })}
                    </select>
                    
                    {selectedCycle && selectedPid && (
                      <div className="mt-3 p-3 bg-light rounded" style={{ border: "1px solid #e0e0e0" }}>
                        {(() => {
                          // Ambil produk base
                          const baseProduct = products.find((p) => p.pid === Number(selectedPid));
                          const basePricing = baseProduct?.pricing?.IDR || {};
                          const basePrice = basePricing[selectedCycle] || 0;
                          
                          // Tentukan produk final dan hitung backup cost
                          let displayProduct = baseProduct;
                          let finalPid = Number(selectedPid);
                          let backupCost = 0;
                          // let velocityCostAmount = 0; // COMMENTED: Velocity feature
                          let finalPrice = basePrice;
                          
                          if (backupOption === "harian") {
                            const backupProduct = findBackupProduct(selectedPid);
                            if (backupProduct) {
                              displayProduct = backupProduct;
                              finalPid = backupProduct.pid;
                              const backupPricing = backupProduct.pricing?.IDR || {};
                              const backupPrice = backupPricing[selectedCycle] || 0;
                              backupCost = backupPrice - basePrice;
                              finalPrice = backupPrice;
                            }
                          }
                          
                          // COMMENTED: Velocity feature
                          // if (velocityEnabled) {
                          //   const velocityProduct = findVelocityProduct(selectedPid);
                          //   if (velocityProduct) {
                          //     displayProduct = velocityProduct;
                          //     finalPid = velocityProduct.pid;
                          //     const velocityPricing = velocityProduct.pricing?.IDR || {};
                          //     const velocityPrice = velocityPricing[selectedCycle] || 0;
                          //     velocityCostAmount = velocityPrice - basePrice;
                          //     finalPrice = velocityPrice;
                          //   }
                          // }
                          
                          const monthlyPrice = displayProduct?.pricing?.IDR?.monthly || 0;
                          const { hematAmount, originalPrice } = calculateHemat(
                            finalPid,
                            selectedCycle,
                            finalPrice,
                            monthlyPrice
                          );

                          return (
                            <div>
                              {(backupOption === "harian" && backupCost > 0) ? (
                                // Tampilan detail untuk backup harian
                                <div>
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="hosting-price-label" style={{ fontSize: "14px", color: "#666" }}>Harga Produk:</span>
                                    <strong className="hosting-price-value" style={{ fontSize: "15px", color: "#333" }}>{formatIDR(basePrice)}</strong>
                                  </div>
                                  
                                  {backupOption === "harian" && backupCost > 0 && (
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <span className="hosting-price-label" style={{ fontSize: "14px", color: "#666" }}>
                                        <span className="badge bg-info text-dark me-2" style={{ fontSize: "11px" }}>Backup Harian</span>
                                      </span>
                                      <strong className="hosting-price-backup" style={{ fontSize: "15px", color: "#17a2b8" }}>+ {formatIDR(backupCost)}</strong>
                                    </div>
                                  )}
                                  
                                  {/* COMMENTED: Velocity feature */}
                                  {/* {velocityEnabled && velocityCostAmount > 0 && (
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <span className="hosting-price-label" style={{ fontSize: "14px", color: "#666" }}>
                                        <span className="badge bg-success text-white me-2" style={{ fontSize: "11px" }}>Velocity (cPanel)</span>
                                      </span>
                                      <strong className="hosting-price-velocity" style={{ fontSize: "15px", color: "#28a745" }}>+ {formatIDR(velocityCostAmount)}</strong>
                                    </div>
                                  )} */}
                                  
                                  <div className="hosting-price-divider" style={{ borderTop: "2px solid #dee2e6", margin: "8px 0" }}></div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <strong className="hosting-price-total-label" style={{ fontSize: "16px", color: "#333" }}>Total:</strong>
                                    <div className="text-end">
                                      <strong className="hosting-price-total-value" style={{ fontSize: "18px", color: "#ee4d30" }}>{formatIDR(finalPrice)}</strong>
                                      {originalPrice && originalPrice > finalPrice && (
                                        <div className="small text-muted hosting-price-original">
                                          <s>{formatIDR(originalPrice)}</s>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  {hematAmount > 0 && (
                                    <div className="text-end mt-2">
                                      <span className="badge btn-cta p-2" style={{ fontSize: "12px" }}>
                                        Hemat {formatIDR(hematAmount)}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                // Tampilan normal untuk mingguan
                            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
                              <div>
                                    <strong className="hosting-price-simple" style={{ fontSize: "16px", color: "#333" }}>Harga: {formatIDR(finalPrice)}</strong>
                                    {originalPrice && originalPrice > finalPrice && (
                                  <div className="small text-muted mt-1 hosting-price-original">
                                    <s>{formatIDR(originalPrice)}</s>
                                  </div>
                                )}
                              </div>
                              {hematAmount > 0 && (
                                <span className="badge btn-cta p-2 hosting-price-savings" style={{ fontSize: "13px" }}>
                                  Hemat {formatIDR(hematAmount)}
                                </span>
                                  )}
                                </div>
                              )}
                            </div>
                          );
                        })()}
                      </div>
                    )}
                  </div>
                )}
                
                <div className="col-12 d-flex justify-content-center mt-5 mb-3">
                  <button
                    className="btn btn-outline-qw-primary fw-bold px-5 py-2 rounded-5 add-to-cart"
                    style={{ fontSize: "15px", minWidth: "180px" }}
                    onClick={handleAddToCart}
                    disabled={!selectedGid || !selectedPid || !selectedCycle}
                  >
                    Tambah ke Keranjang
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Modal show={showConfirmModal} onHide={handleCancelReplace} centered>
        <Modal.Header closeButton>
          <Modal.Title>Konfirmasi Perubahan Produk</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p style={{ fontSize: "18px" }}>
              Anda sudah memiliki produk terpilih di keranjang. Apakah Anda yakin ingin mengganti produk tersebut dengan produk yang baru?
            </p>
          </div>
          <div className="row mt-5">
            <div className="col-lg-6 col-12">
              <button
                className="btn btn-modal-outline-daftar-secondary w-100"
                onClick={handleCancelReplace}
              >
                Kembali
              </button>
            </div>
            <div className="col-lg-6 col-12">
              <button
                className="btn btn-modal-confirmation w-100"
                onClick={handleConfirmReplace}
              >
                Setuju
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Card ExistingDomain muncul otomatis jika ada hosting dan belum ada domain */}
      {hasHosting && !hasDomain && (
        <ExistingDomain domainMethod="existing" setDomainMethod={() => { }} />
      )}
    </>
  );
};

export default HostingProductSelectorNew; 